import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import {
  UniFeeGrowthHoulies,
  UNI_FEE_GROWTH_HOURLY_QUERY
} from '../../queries/interestQuery'
import { UniswapClient } from '../../utils/apollo-client'

export function useUniFeeGrowthHourly(
  chainId: number,
  contractAddress: string
) {
  const { data, loading } = useQuery<UniFeeGrowthHoulies>(
    UNI_FEE_GROWTH_HOURLY_QUERY,
    {
      fetchPolicy: 'cache-first',
      variables: {
        contractAddress
      },
      pollInterval: 15000,
      client: UniswapClient[chainId]
    }
  )

  const uniFeeGrowth = useMemo(() => {
    if (data) {
      return data.uniFeeGrowthHourlies
        .map(item => ({
          address: item.address,
          feeGrowthGlobal0X128: BigInt(item.feeGrowthGlobal0X128),
          feeGrowthGlobal1X128: BigInt(item.feeGrowthGlobal1X128),
          timestamp: Number(item.updatedAt)
        }))
        .filter(data => data.address === contractAddress.toLowerCase())
    }
    return null
  }, [data, contractAddress])

  if (loading || uniFeeGrowth === null) {
    return null
  }

  return [...uniFeeGrowth].reverse()
}
